<template>
    <!-- 头部标题 -->
    <div class="header">
            <header class="title">{{ info.dataType }}</header>
            <div class="content">
                <span>{{ info.dataName }}</span>
            </div>
            <van-row type="flex" class="footer" justify="center">
                <van-col span="12">编号：{{ info.dataId }}</van-col>
                <van-col span="12">
                    <van-icon name="user-o"> {{ submitUserName }}</van-icon>
                </van-col>
            </van-row>
        </div>
</template>
<script>
export default {
    props: {
        info: {
            type: Object,
            require: true
        },
        submitUserName:'',
    },
    data(){
        return {
            icon: require('../../../assets/img/calendar.png')
        }
    }
}
</script>
<style lang="less" scoped>
    //主标题字号
    @titleSize: 16px;
    //主标题颜色
    @titleColor: #0ea6e0;
    //主体小字字号
    @contentSize: 12px;
    //内容小字颜色
    @contentColor: #7f7f7f;
    //板块radius
    @borderRadius: 4px;
    //边框阴影
    @boxShadow: 2px 2px 5px 0 rgba(0, 0, 0, 0.2);

    .header{
        font-size: @titleSize;
        background-color: #fff;
        border-radius: @borderRadius;
        box-shadow: @boxShadow;
        overflow: hidden;
        .title{
            text-align: left;
            color: @titleColor;
            margin: 20px 0 0 15px;
        }
        .content{
            margin: 5px 15px;
            text-align: left;
        }
        .footer{
            font-size: @contentSize;
            color: @contentColor;
            text-align: center;
            align-items: center;
            margin: 30px 0 5px 15px;
            .calendar{
                display: flex;
                align-items: center;
                justify-content: center;
                img{
                    width: 12px;
                    height: 12px;
                    margin: 0 3px 3px 0;
                }
            }
        }
    }
</style>